export default class Aria {
  /**
   * Sets the `aria-expanded` attribute on the given element.
   *
   * @param {HTMLElement} el - The DOM element on which to set the attribute.
   * @param {boolean} [isExpanded=false] - Whether the element is expanded (`true`) or collapsed (`false`).
   */
  static setExpanded(el, isExpanded = false) {
    if (!el) {
      return;
    }

    if (isExpanded) {
      el.setAttribute('aria-expanded', 'true');
    } else {
      el.setAttribute('aria-expanded', 'false');
    }
  }
}
